import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { StyledSelect } from "../Select";
import { SelectSheet } from "./SelectSheet";
import { SelectPill } from "./styles";
import { ResponsiveSelectProps, SelectSheetOption } from "./types";

export const ResponsiveSelect: React.FC<ResponsiveSelectProps> = ({
  isCompact,
  options,
  value,
  onChange,
  sheetTitle,
  placeholder = "",
  testId,
}) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  const selectedOption =
    options.find((option) => option.value === value) ?? null;
  const pillLabel = selectedOption?.label ?? placeholder;

  const handleSheetSelect = (option: SelectSheetOption) => {
    onChange(option);
    setIsSheetOpen(false);
  };

  const handleDesktopChange = (newValue: unknown) => {
    const option = newValue as SelectSheetOption | null;
    if (option) {
      onChange(option);
    }
  };

  if (isCompact) {
    return (
      <>
        <SelectPill
          type="button"
          data-testid={testId}
          aria-label={`${sheetTitle}: ${pillLabel}`}
          onClick={() => setIsSheetOpen(true)}
        >
          {pillLabel}
          <KeyboardArrowDownIcon />
        </SelectPill>
        <SelectSheet
          isOpen={isSheetOpen}
          title={sheetTitle}
          options={options}
          selectedValue={value ?? undefined}
          onSelect={handleSheetSelect}
          onClose={() => setIsSheetOpen(false)}
        />
      </>
    );
  }

  return (
    <StyledSelect
      testId={testId}
      options={options}
      value={selectedOption}
      handleChange={handleDesktopChange}
      ariaLabel={sheetTitle}
    />
  );
};
